export default "__VITE_ASSET__tOqRaXYP__"